// extracted by mini-css-extract-plugin
export default {"Header":"CloseView_Header__UXmEP","Label":"CloseView_Label__I1EpX","NotUseButton":"CloseView_NotUseButton__sc4MX","UseButton":"CloseView_UseButton__wd2Rd"};